import React, { Component } from 'react'
import MUIDataTable from 'mui-datatables'
import gql from 'graphql-tag'
import { withApollo } from 'react-apollo'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import PropTypes, { element } from 'prop-types'
import Typography from '@material-ui/core/Typography'
import getLoginId from '../../../utils/getLoginId'
import getAccountType from '../../../utils/getAccountType'
import Loader from '../../../components/common/Loader'
import { AppBar, Tabs, Tab } from '@material-ui/core'

const GET_ALL_CLIENT_SUBSCRIPTION = gql`
  query getAllSubscriptions($partnerLoginId: Int!, $status: [Int!]) {
    allClientSubscriptions: getAllSubscriptions(
      partnerLoginId: $partnerLoginId
      status: $status
    ) {
      id
      client {
        loginId
        clientName
      }
      billingMode {
        id
        billingMode
      }
      billingFrequency {
        id
        frequency
      }
      deviceModel {
        model_name
      }
      serviceProvider {
        name
      }
      deviceQuantity
      plan
      amount
      status
      createdAt
      nextPaymentDate
    }
  }
`

const GET_ALL_PARTNER_SUBSCRIPTION = gql`
  query getAllPartnerSubscriptions($partnerLoginId: Int, $status: [Int!]) {
    allPartnerSubscriptions: getAllPartnerSubscriptions(
      partnerLoginId: $partnerLoginId
      status: $status
    ) {
      id
      status
      partnerLoginId
      gst
      amount
      totalDeviceQty
      unassignedDeviceQuantity
      billingFrequencyId
      hardwareCharges
      totalSoftwareQty
      unbilledSoftware
      totalSoftwareQty
      unbilledSoftware
      noOfDevices
      deviceTrackingCharges
      simQty
      unbilledSims
      unassignedSimQty
      unassignedSimQty
      simCharges
      accessoryQty
      unbilledAccessory
      unassignedAccessoryQty
      unbilledDeviceQty
      nextPaymentDate
      accessoryCharges
      unassignedAccessoryQty
      nextPaymentDate
      deviceModel {
        model_name
      }
      serviceProvider {
        name
      }
      createdAt
      partnerDetail {
        id
        businessName
      }
      billingMode {
        id
        billingMode
      }
      billingFrequency {
        id
        frequency
        numberOfMonths
      }
    }
  }
`

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  }
})

class Subscriptions extends Component {
  constructor(props) {
    super(props)
    this.classes = props
    this.state = {
      isLoading: true,
      currentTab: 'CLIENT',
      query: GET_ALL_CLIENT_SUBSCRIPTION,
      clientQueryVariables: null,
      tableRowDataClient: [],
      tableRowDataPartner: []
    }
  }
  clientId = []
  fullData = []

  columnsClient = [
    'CUSTOMER NAME',
    'PLAN',
    {
      name: 'DEVICE COUNT',
      options: {
        filter: false
      }
    },
    'MODEL NAME',
    'SERVICE PROVIDER',
    'BILLING MODE',
    'BILLING FREQUENCY',
    {
      name: 'SOFTWARE MMTC ( in Rs )',
      options: {
        filter: false
      }
    },
    'STATUS',
    'CREATION DATE',
    'NEXT BILLING DATE'
  ]

  columnsPartner = [
    'CUSTOMER NAME',
    'DEVICE COUNT',
    'MODEL NAME',
    'SERVICE PROVIDER',
    'BILLING MODE',
    'BILLING FREQUENCY',
    {
      name: 'SOFTWARE MMTC ( in Rs )',
      options: {
        filter: false
      }
    },
    'STATUS',
    'CREATION DATE',
    'NEXT BILLING DATE'
  ]

  // SetCurrentPageNumber = pageNumber => {
  //   console.log('page number', pageNumber)
  //   let pageNumber1 = pageNumber
  //   sessionStorage.setItem('currentPageNumber', pageNumber1)
  //   let sessionvar = sessionStorage.getItem('currentPageNumber')
  //   if (sessionvar < ) {
  //     sessionStorage.clear()
  //   }
  //   // let sessionvar = sessionStorage.getItem('currentPageNumber')
  //   console.log('session var', sessionvar)
  // }

  optionsClient = {
    filterType: 'dropdown',
    print: false,
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 10,
    onRowClick: (rowData, dataIndex, rowIndex) => {
      // console.log('data Index', dataIndex, rowData)
      this.props.history.push({
        pathname:
          '/home/subscriptions/view/' +
          this.clientId[dataIndex.dataIndex] +
          '/' +
          this.subcriptionIdClient[dataIndex.dataIndex]
      })
    },
    onChangeRowsPerPage: numberOfRows => {
      console.log('current page', numberOfRows)
    }
    // onChangePage: (currentPage) => {
    //   this.SetCurrentPageNumber(currentPage)
    // }
  }

  optionsPartner = {
    filterType: 'dropdown',
    print: false,
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 15,
    onRowClick: (rowData, dataIndex, rowIndex) => {
      this.props.history.push({
        pathname:
          '/home/subscriptions' +
          '/' +
          this.subcriptionIdPartner[dataIndex.dataIndex] +
          '/partnerSubscriptionDetail'
      })
    }
  }

  handleTabChange = (event, value) => {
    // console.log('on tab change', event, value)
    switch (value) {
      case 'CLIENT':
        // console.log('call Client Subscriptions')
        this.getAllClientSubscriptions()
        break
      case 'PARTNER':
        // console.log('call Partner Subscription')
        this.getAllPartnerSubsciptions()

        break
      default:
        console.log('call client')
        break
    }
    this.setState({ currentTab: value })
  }

  createNewSubscription = e => {
    this.props.history.push({
      pathname: '/home/subscriptions/new'
    })
  }

  // epoch to human readable date format
  epochToDate = date1 => {
    const d1 = parseInt(date1, 10)
    const unixEpochTimeMS = d1 * 1000
    const d = new Date(unixEpochTimeMS)
    // Careful, the string output here can vary by implementation...
    const strDate = d.toLocaleDateString()
    return strDate
  }

  // *********TableStatus of subscription master ***********************
  // ********* 1 - Pending
  // ********* 2 - Approved and partial payment
  // ********* 3 - Rejected
  // ********* 4 - Pending of already approved subscription.
  // ********* 5 - Approved and fully paid
  //  for Partner subcription query Status value is not passing. This bug will be fixed once fixed in backend

  mapToArrPartner(allSubscriptions) {
    // let rs = &#8377;
    var rowData = []
    this.fullData = []
    this.clientId = []
    this.subcriptionIdPartner = []
    allSubscriptions.forEach(element => {
      rowData = []
      this.subcriptionIdPartner.push(element.id)
      rowData.push(element.partnerDetail.businessName)
      rowData.push(element.totalSoftwareQty)
      rowData.push(element.deviceModel.model_name)
      if (
        element.serviceProvider === null ||
        element.serviceProvider === undefined
      ) {
        rowData.push('NA')
      } else {
        rowData.push(element.serviceProvider.name)
      }
      if (element.billingMode) {
        rowData.push(element.billingMode.billingMode)
      } else {
        rowData.push('N/A')
      }
      rowData.push(element.billingFrequency.frequency)
      rowData.push(element.deviceTrackingCharges)
      if (element.status === 1 || element.status === 4) {
        rowData.push('Pending')
      } else if (element.status === 2 || element.status === 5) {
        rowData.push('Approved')
      } else if (element.status === 3) {
        rowData.push('Rejected')
      }
      rowData.push(this.epochToDate(element.createdAt))
      rowData.push(this.epochToDate(element.nextPaymentDate))
      this.fullData.push(rowData)
    })
    // console.log('subscription table data', this.fullData)
    this.setState({
      tableRowDataPartner: this.fullData
    })
  }

  mapToArrClient(allSubscriptions) {
    var rowData = []
    this.fullData = []
    this.clientId = []
    this.subcriptionIdClient = []
    allSubscriptions.forEach(element => {
      console.log('element.serviceProvider', element.serviceProvider)
      rowData = []
      this.clientId.push(element.client.loginId)
      this.subcriptionIdClient.push(element.id)
      rowData.push(element.client.clientName)
      if (element.plan) {
        rowData.push(element.plan)
      } else {
        rowData.push('NA')
      }
      rowData.push(element.deviceQuantity)
      rowData.push(element.deviceModel.model_name)
      if (
        element.serviceProvider === null ||
        element.serviceProvider === undefined
      ) {
        rowData.push('NA')
      } else {
        rowData.push(element.serviceProvider.name)
      }

      rowData.push(element.billingMode.billingMode)
      rowData.push(element.billingFrequency.frequency)
      rowData.push(element.amount)
      if (element.status === 1 || element.status === 4) {
        rowData.push('Pending')
      } else if (element.status === 2 || element.status === 5) {
        rowData.push('Approved')
      } else if (element.status === 3) {
        rowData.push('Rejected')
      }
      rowData.push(this.epochToDate(element.createdAt))
      rowData.push(this.epochToDate(element.nextPaymentDate))
      // rowData.push(element.createdAt)
      this.fullData.push(rowData)
    })
    // console.log('subscription table data', this.fullData)
    this.setState({
      tableRowDataClient: this.fullData
    })
  }

  setClientQueryVariables = () => {
    const queryVariables = {
      partnerLoginId: getLoginId()
    }

    if (['SAL', 'PA'].includes(getAccountType())) {
      queryVariables['status'] = [1, 2, 4, 5]
    }

    if (['ACC'].includes(getAccountType())) {
      queryVariables['status'] = [1, 4]
    }

    if (['INV'].includes(getAccountType())) {
      queryVariables['status'] = [2, 4, 5]
    }
    return queryVariables
  }

  setPartnerQueryVariables = () => {
    const queryVariables = {
      partnerLoginId: null
    }

    if (['SAL'].includes(getAccountType())) {
      queryVariables['status'] = [1, 2, 4, 5]
    }

    if (['ACC'].includes(getAccountType())) {
      queryVariables['status'] = [1, 4]
    }

    if (['INV'].includes(getAccountType())) {
      queryVariables['status'] = [2]
    }
    return queryVariables
  }

  getAllClientSubscriptions = async () => {
    // console.log('partnerLogin id', this.state.queryVariables)
    const { data, loading, error } = await this.props.client.query({
      query: GET_ALL_CLIENT_SUBSCRIPTION,
      variables: this.state.clientQueryVariables,
      // fetchPolicy: 'network-only'
    })
    if (loading) return <Loader />
    if (error) return `Error!: ${error}`
    // console.log(
    //   'all subscription data',
    //   data.allClientSubscriptions[0].serviceProvider.name
    // )
    this.setState({ isLoading: loading })
    // console.log('loading status', loading)
    this.mapToArrClient(data.allClientSubscriptions)
  }

  getAllPartnerSubsciptions = async () => {
    console.log('account type', getAccountType())
    if (getAccountType() !== 'PA') {
      const partnerQueryVariables = this.setPartnerQueryVariables()

      const { data, loading, error } = await this.props.client.query({
        query: GET_ALL_PARTNER_SUBSCRIPTION,
        variables: partnerQueryVariables,
        // fetchPolicy: 'network-only'
      })
      if (loading) return <Loader />
      if (error) return `Error!: ${error}`
      console.log('all subscription data', data)
      this.mapToArrPartner(data.allPartnerSubscriptions)
    }
  }

  componentDidMount = () => {
    const clientQueryVariables = this.setClientQueryVariables()
    // console.log('clientQueryVariables', clientQueryVariables)
    this.setState({ clientQueryVariables }, () => {
      this.getAllClientSubscriptions()
    })
  }

  render() {
    const { classes } = this.props
    const { currentTab } = this.state
    // loader display before data loading for better ui experience
    if (this.state.isLoading) {
      return <Loader />
    } else {
      return (
        <div className={classes.root}>
          <Grid container spacing={16} direction="row">
            <Grid item xs={12}>
              <Grid container spacing={16} justify="space-between">
                <Grid item>
                  <Typography variant="headline">All Subscriptions</Typography>
                </Grid>
                {!['INV', 'ACC'].includes(getAccountType()) && (
                  <Grid item xs={12} sm="auto">
                    <Button
                      fullWidth
                      color="secondary"
                      onClick={this.createNewSubscription}
                      variant="contained"
                      className={classes.button}
                    >
                      New Subscription
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          <br />
          <Grid item xs={12}>
            {!['SAL'].includes(getAccountType()) && (
              <AppBar position="static">
                <Tabs value={currentTab} onChange={this.handleTabChange}>
                  <Tab value="CLIENT" label="Clients" />
                  {getLoginId() === 2 ? (
                    !['INV'].includes(getAccountType()) ? (
                      <Tab value="PARTNER" label="Partners" />
                    ) : null
                  ) : null}
                </Tabs>
              </AppBar>
            )}
            {/* TODO: Replace this with a custom table going forward */}
            <MUIDataTable
              data={
                currentTab === 'CLIENT'
                  ? this.state.tableRowDataClient
                  : this.state.tableRowDataPartner
              }
              columns={
                // this.columnsClient
                currentTab === 'CLIENT'
                  ? this.columnsClient
                  : this.columnsPartner
              }
              options={
                currentTab === 'CLIENT'
                  ? this.optionsClient
                  : this.optionsPartner
              }
            />
            {/* {currentTab === 'CLIENT' ? (

            ) : (
              <MUIDataTable
                data={
                  currentTab === 'CLIENT'
                    ? this.state.tableRowDataClient
                    : this.state.tableRowDataPartner
                }
                columns={
                  // this.columnsClient
                  currentTab === 'CLIENT'
                    ? this.columnsClient
                    : this.columnsPartner
                }
                options={
                  currentTab === 'CLIENT'
                    ? this.optionsClient
                    : this.optionsPartner
                }
              />
              {/* {currentTab === 'CLIENT' ? (
              ) : (
                <MUIDataTable
                  data={this.state.tableRowData}
                  columns={this.columnsPartner}
                  options={this.options}
                />
              )} */}
          </Grid>
        </div>
      )
    }
  }
}

Subscriptions.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(style)(withApollo(Subscriptions))



// WEBPACK FOOTER //
// ./src/components/Pages/Subscriptions/index.jsx